"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoImageIcon = exports.Image = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const svg_components_1 = require("@/assets/svg-components");
exports.Image = styled_components_1.default.img `
  width: 100%;
  height: 100%;
  aspect-ratio: 1 / 1;
  object-fit: contain;
`;
exports.NoImageIcon = (0, styled_components_1.default)(svg_components_1.NoImageIcon) `
  width: 100%;
  height: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
`;
exports.default = {
    Image: exports.Image
};
